import { createReconciliationService } from './ReconciliationService.impl';
import { myReconciliationApi } from '../../../api/reconciliation/reconciliation.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { myV1ActionEvent } from 'v4/migration/actionAsEventMiddleware.connected';
import { queryClient } from 'v4/migration/queryClientSingleton';

export const myReconciliationService = createReconciliationService({
  api: myReconciliationApi,
  queryClient,
  v1Event: myV1ActionEvent,
  services: {
    errorService: myErrorService,
    messageService: myMessageService
  }
});
